import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import dayjs from "dayjs";

export default function PaymentTimeline({ data, month }) {
  if (!data || !data[month]) {
    return <Typography>No data available</Typography>;
  }

  const schedules = [...data[month].schedules].sort(
    (a, b) => new Date(a.date) - new Date(b.date),
  );

  return (
    <Box>
      {/* Month Header */}
      <Typography variant="h5" fontWeight={600} mb={2}>
        {month} — ₹ {data[month].totalAmount.toLocaleString()}
      </Typography>

      {/* Timeline */}
      <Stack spacing={2}>
        {schedules.map((item, index) => (
          <Box
            key={index}
            sx={{
              p: 2,
              borderRadius: 3,
              backdropFilter: "blur(10px)",
              background: "rgba(255,255,255,0.05)",
              border: "1px solid rgba(255,255,255,0.1)",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 2,
            }}
          >
            {/* LEFT: DATE */}
            <Box sx={{ minWidth: 120 }}>
              <Typography fontWeight={600}>
                {dayjs(item.date).format("DD MMM YYYY")}
              </Typography>
            </Box>

            {/* CENTER: PROJECT INFO */}
            <Box sx={{ flex: 1 }}>
              <Typography fontWeight={600}>{item.project_name}</Typography>
              <Typography variant="body2" sx={{ opacity: 0.7 }}>
                {item.customer_name}
              </Typography>
            </Box>

            {/* BD */}
            <Box sx={{ minWidth: 140 }}>
              <Typography variant="body2">
                BD: <b>{item.bd_name}</b>
              </Typography>
            </Box>

            {/* AMOUNT */}
            <Box sx={{ minWidth: 140 }}>
              <Typography fontWeight={700} sx={{ color: "#22c55e" }}>
                ₹ {item.amount.toLocaleString()}
              </Typography>
            </Box>

            {/* PHASE */}
            <Box sx={{ minWidth: 120 }}>
              <Typography variant="body2">
                Phase: {item.current_phase} of {item.total_phases}
              </Typography>
            </Box>
          </Box>
        ))}
      </Stack>
    </Box>
  );
}
